(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vega-comparison-table"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__vgFadeInit) return;
  window.__vgFadeInit = true;
  var init = function (root) {
    var els = (root || document).querySelectorAll('.vg-fade-up');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vg-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('vg-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -48px 0px' });
    els.forEach(function (el) { io.observe(el); });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vega-concession"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__vgFadeInit) return;
  window.__vgFadeInit = true;
  var init = function (root) {
    var els = (root || document).querySelectorAll('.vg-fade-up');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vg-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('vg-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -48px 0px' });
    els.forEach(function (el) { io.observe(el); });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vega-differentiators"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__vgFadeInit) return;
  window.__vgFadeInit = true;
  var init = function (root) {
    var els = (root || document).querySelectorAll('.vg-fade-up');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vg-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('vg-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -48px 0px' });
    els.forEach(function (el) { io.observe(el); });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vega-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  var init = function (root) {
    root.querySelectorAll('.vg-faq-item').forEach(function (item) {
      var btn = item.querySelector('.vg-faq-q');
      if (!btn || btn.__vgBound) return;
      btn.__vgBound = true;
      btn.addEventListener('click', function () {
        var open = item.classList.toggle('vg-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

(function () {
  if (window.__vgFadeInit) return;
  window.__vgFadeInit = true;
  var init = function (root) {
    var els = (root || document).querySelectorAll('.vg-fade-up');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vg-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('vg-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -48px 0px' });
    els.forEach(function (el) { io.observe(el); });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vega-final-cta"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__vgFadeInit) return;
  window.__vgFadeInit = true;
  var init = function (root) {
    var els = (root || document).querySelectorAll('.vg-fade-up');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vg-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('vg-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -48px 0px' });
    els.forEach(function (el) { io.observe(el); });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vega-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__vgFadeInit) return;
  window.__vgFadeInit = true;
  var init = function (root) {
    var els = (root || document).querySelectorAll('.vg-fade-up');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vg-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('vg-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -48px 0px' });
    els.forEach(function (el) { io.observe(el); });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vega-ingredients"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__vgFadeInit) return;
  window.__vgFadeInit = true;
  var init = function (root) {
    var els = (root || document).querySelectorAll('.vg-fade-up');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vg-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('vg-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -48px 0px' });
    els.forEach(function (el) { io.observe(el); });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vega-pricing"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__vgFadeInit) return;
  window.__vgFadeInit = true;
  var init = function (root) {
    var els = (root || document).querySelectorAll('.vg-fade-up');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vg-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('vg-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -48px 0px' });
    els.forEach(function (el) { io.observe(el); });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vega-social-proof"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__vgFadeInit) return;
  window.__vgFadeInit = true;
  var init = function (root) {
    var els = (root || document).querySelectorAll('.vg-fade-up');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vg-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('vg-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -48px 0px' });
    els.forEach(function (el) { io.observe(el); });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vega-stats-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__vgFadeInit) return;
  window.__vgFadeInit = true;
  var init = function (root) {
    var els = (root || document).querySelectorAll('.vg-fade-up');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vg-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('vg-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -48px 0px' });
    els.forEach(function (el) { io.observe(el); });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vega-sticky-cta"] && !Shopify.designMode) return;
  try {
    
(function () {
  var el = document.currentScript ? document.currentScript.previousElementSibling : null;
  var bar = document.querySelector('.vg-sticky-cta');
  if (!bar) return;
  var threshold = parseInt(bar.getAttribute('data-show-after'), 10) || 50;
  var onScroll = function () {
    if (window.scrollY > threshold) bar.classList.add('vg-visible');
    else bar.classList.remove('vg-visible');
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vega-timeline"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__vgFadeInit) return;
  window.__vgFadeInit = true;
  var init = function (root) {
    var els = (root || document).querySelectorAll('.vg-fade-up');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vg-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('vg-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -48px 0px' });
    els.forEach(function (el) { io.observe(el); });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vega-tldr"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__vgFadeInit) return;
  window.__vgFadeInit = true;
  var init = function (root) {
    var els = (root || document).querySelectorAll('.vg-fade-up');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vg-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('vg-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -48px 0px' });
    els.forEach(function (el) { io.observe(el); });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
